var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLayoutCommon2X3 = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 18,
  viewBox: "0 0 28 18",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "currentColor",
  transform: "translate(1 1)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 26,
  height: 15.6,
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M9 0H2a2 2 0 0 0-2 2v11.6a2 2 0 0 0 2 2h7z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17 0H2a2 2 0 0 0-2 2v11.6a2 2 0 0 0 2 2h15z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24 0H2a2 2 0 0 0-2 2v6h26V2a2 2 0 0 0-2-2Z"
}))));
export { SvgLayoutCommon2X3 as ReactComponent };
export default __webpack_public_path__ + "assets/images/layout-common-2x3.svg";